import Swal from "sweetalert2";
import { planesDePagoService } from "../../../_services/planesDePago.service";
import { dashboardConstants } from "../constants";

export const getPlanes = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await planesDePagoService.getPlanes(data);

    if (!Array.isArray(response)) {      
      dispatch(failure(response));

      return Swal.fire({
        icon: "error",
        title: "Error",
        text: response?.mensaje || "Ocurrio un error, intentelo nuevamente o revise los filtros ingresados.",
      });
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED, payload: { planesList: [] } };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(data) {
    return { type: dashboardConstants.SET_PLANES_LIST, payload: data };
  }
};

export const getPlan = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await planesDePagoService.getPlan(data);

    if (typeof response === "string") {      
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(data) {
    return { type: dashboardConstants.SET_PLAN, payload: data };
  }
};

export const getPlanDePago = (id) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await planesDePagoService.getPlanDePago(id);

    if (typeof response === "string") {      
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(data) {
    return { type: dashboardConstants.SET_PLAN_PAGO, payload: data };
  }
};

export const getPlanData = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await planesDePagoService.getPlanData(data);

    if (typeof response === "string") {      
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(data) {
    return { type: dashboardConstants.SET_PLANES_DATA, payload: data };
  }
}
;
export const getLegalPlanes = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await planesDePagoService.getLegalPlanes(data);

    if (typeof response === "string") {      
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(data) {
    return { type: dashboardConstants.SET_PLANES_DATA, payload: data };
  }
};

export const setEstado = (data) => async (dispatch) => {
  dispatch(request());
  try {
    const response = await planesDePagoService.setEstado(data);
    if (typeof response === "string") {
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }
  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(data) {
    return { type: dashboardConstants.SET_PLANES_LIST, payload: data };
  }
};
